import React, { memo } from "react";
import { TableCell, TableRow, TableSortLabel, Typography } from "@mui/material";

function CabecalhoNotasFiscais({ orderBy, orderDirection, onRequestSort }) {
  const renderSortableHeader = (label, field) => {
    const isActive = orderBy === field;

    return (
      <TableSortLabel
        active={isActive}
        direction={isActive ? orderDirection : "asc"}
        onClick={() => onRequestSort(field)}
        sx={{
          width: "100%",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          py: 0.25,
          color: "text.primary",
          "& .MuiTableSortLabel-icon": {
            marginLeft: 0.25,
            opacity: isActive ? 1 : 0.35,
          },
          "&.Mui-active .MuiTableSortLabel-icon": {
            color: "primary.main",
          },
        }}
      >
        <Typography component="span" variant="body2" sx={{ fontWeight: 500 }}>
          {label}
        </Typography>
      </TableSortLabel>
    );
  };

  return (
    <TableRow>
      <TableCell
        align="center"
        width={80}
        sx={{
          py: 1.25,
          backgroundColor: "#f7f8fa",
          borderBottom: "1px solid #dfe3e8",
        }}
      >
        Detalhes
      </TableCell>
      <TableCell
        align="center"
        sx={{
          py: 1.25,
          backgroundColor: "#f7f8fa",
          borderBottom: "1px solid #dfe3e8",
        }}
      >
        {renderSortableHeader("Nota fiscal", "nota_fiscal")}
      </TableCell>
      <TableCell
        align="center"
        sx={{
          py: 1.25,
          backgroundColor: "#f7f8fa",
          borderBottom: "1px solid #dfe3e8",
        }}
      >
        {renderSortableHeader("Valor", "valor")}
      </TableCell>
      <TableCell
        align="center"
        sx={{
          py: 1.25,
          backgroundColor: "#f7f8fa",
          borderBottom: "1px solid #dfe3e8",
        }}
      >
        {renderSortableHeader("Data", "data")}
      </TableCell>
      <TableCell
        align="center"
        sx={{
          py: 1.25,
          backgroundColor: "#f7f8fa",
          borderBottom: "1px solid #dfe3e8",
        }}
      >
        {renderSortableHeader("Código da nota", "codigo_nota")}
      </TableCell>
      <TableCell
        align="center"
        sx={{
          py: 1.25,
          backgroundColor: "#f7f8fa",
          borderBottom: "1px solid #dfe3e8",
        }}
      >
        {renderSortableHeader("Convênio", "convenio")}
      </TableCell>
    </TableRow>
  );
}

export default memo(CabecalhoNotasFiscais);
